/* =====================================================
   3DM PRODUCT V7 – DESKTOP INTERACTIONS (FIXED)
   ===================================================== */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const root = document.querySelector("[data-product-3dm-v7]");
    if (!root) return;

    /* -----------------------------
       QTY + / -
    ----------------------------- */
    const qtyInput = root.querySelector("[data-v7-qty-input]");
    root.querySelectorAll("[data-v7-qty]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!qtyInput) return;

        const dir = btn.dataset.v7Qty;
        const current = parseInt(qtyInput.value || "1", 10);
        const next = dir === "+" ? current + 1 : Math.max(1, current - 1);

        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    /* -----------------------------
       THUMB → MAIN IMAGE SWITCH
    ----------------------------- */
    const mainImg = root.querySelector("[data-v7-media-main] img");

    root.querySelectorAll("[data-v7-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const img = thumb.querySelector("img");
        if (!img || !mainImg) return;

        const newSrc = img.src.replace(/width=\d+/, "width=1400");
        mainImg.src = newSrc;
        mainImg.srcset = "";
        mainImg.sizes = "100vw";
      });
    });

    /* -----------------------------
       IMAGE ZOOM (DESKTOP)
    ----------------------------- */
    const zoomImg = root.querySelector("[data-v7-zoom] img");
    if (zoomImg) {
      zoomImg.style.cursor = "zoom-in";

      zoomImg.addEventListener("click", () => {
        const overlay = document.createElement("div");
        overlay.style.position = "fixed";
        overlay.style.inset = "0";
        overlay.style.background = "rgba(0,0,0,0.75)";
        overlay.style.zIndex = "9999";
        overlay.style.display = "flex";
        overlay.style.alignItems = "center";
        overlay.style.justifyContent = "center";
        overlay.style.cursor = "zoom-out";

        const img = document.createElement("img");
        img.src = zoomImg.src.replace(/width=\d+/, "width=2000");
        img.style.maxWidth = "90vw";
        img.style.maxHeight = "90vh";
        img.style.borderRadius = "16px";
        img.style.background = "#fff";

        overlay.appendChild(img);
        document.body.appendChild(overlay);

        overlay.addEventListener("click", () => overlay.remove());
      });
    }

/* -----------------------------
   STICKY MINI ATC (V7 FINAL)
----------------------------- */
  const atc = root.querySelector("[data-v7-atc]");
  const sticky = root.querySelector("[data-v7-sticky]");
  const stickyCTA = root.querySelector("[data-v7-sticky-cta]");
  const priceEl = root.querySelector("[data-v7-price]");
  const stickyPrice = root.querySelector("[data-v7-sticky-price]");

  if (!atc || !sticky || !stickyCTA) return;

  // Preis spiegeln
  if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;

  // Nur Desktop
  const isDesktop = () => window.matchMedia("(min-width: 1000px)").matches;

  // Observer: erscheint, wenn ATC nicht mehr sichtbar ist
  const io = new IntersectionObserver(
    ([entry]) => {
      sticky.hidden = !(isDesktop() && !entry.isIntersecting);
    },
    { threshold: 0.2 }
  );

  io.observe(atc);

  // Klick scrollt zum echten ATC
  stickyCTA.addEventListener("click", () => {
    atc.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => atc.focus?.({ preventScroll: true }), 200);
  });

  // Resize-Sicherheit
  window.addEventListener("resize", () => {
    if (!isDesktop()) sticky.hidden = true;
  });
  });
  /* --------------------------------
   HIDE STICKY MINI ATC ON FOOTER
--------------------------------- */
(function () {
  const sticky = document.querySelector("[data-v7-sticky]");
  const footer = document.querySelector(".footer-3dm");

  if (!sticky || !footer) return;

  const ioFooter = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        sticky.classList.add("is-hidden");
      } else {
        sticky.classList.remove("is-hidden");
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  ioFooter.observe(footer);
})();

})();
